import {
  useUserProfile,
  useUserGroups,
  UserProfileCard,
  LoadingSpinner,
  ApiErrorDisplay,
} from '@authifi/clique-react-ui';

export function UserProfilePage() {
  const { data: user, isLoading, isError, error, refetch } = useUserProfile();
  const {
    data: groups,
    isLoading: groupsLoading,
    isError: groupsIsError,
    error: groupsError,
    refetch: refetchGroups,
  } = useUserGroups();

  if (isLoading) {
    return <LoadingSpinner message="Loading profile..." />;
  }

  if (isError) {
    return <ApiErrorDisplay error={error} resourceLabel="profile" onRetry={() => void refetch()} />;
  }

  if (!user) return null;

  return (
    <div>
      <h2 className="text-2xl font-semibold text-[var(--clique-fg)] mb-6">My Profile</h2>
      <UserProfileCard
        user={user}
        groups={groups}
        groupsLoading={groupsLoading}
        groupsError={groupsIsError ? groupsError : undefined}
        onGroupsRetry={() => void refetchGroups()}
      />
    </div>
  );
}
